import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LicenseUser } from '@portal-core/license-users/models/license-user.model';

@CollectionStateSelectors({
  stateType: LicenseUsersState
})
@State<LicenseUsersState>({
  name: LicenseUsersState.source,
})
@Service({ autoProvided: false })
export class LicenseUsersState extends CollectionStateBase {
  static override source = 'LicenseUsers';
  getSource(): string {
    return LicenseUsersState.source;
  }
}

@Service()
export class LicenseUsersDataService extends CollectionDataServiceBase<LicenseUser> {
  protected readonly stateType = LicenseUsersState;
}
